export enum EffectOnEffectWrk {
  /// <summary>
  /// افزاینده
  /// </summary>
  Increment = 1,
  /// <summary>
  /// کاهنده
  /// </summary>
  Decrement = 2,
  /// <summary>
  /// خنثی
  /// </summary>
  Neutral = 3,
}
